<template>
  <div>
      <Header title="即时评教" type="0" route="/student/evaluateOnTime" ></Header>
      <div class="tittleDiv">
         <div class="list-head">
          <p>{{baseData.kcmc}}</p>
          <ul>
            <li>上课老师：{{baseData.jgxm}}</li>
          </ul>
         </div>
      </div>
      <div class="eva-body">
        <p>评论：</p>
        <keep-alive>
				<textarea
				  placeholder="请点击填写"
				  v-model="evaText"
				  maxlength="2000"
          
				></textarea>
			  </keep-alive>
        <div class="eva-body-ts"><span>最多2000字符</span></div>
       <!--- <div class="grey-contain">
          
        </div>-->
        <div class="grey-contain_div" ></div>
      </div>
      <div class="history-btn">
        <button @click="submintPjData()">提交</button>
        <button @click="lookMyEvaluateRecod()">查看评价记录</button>
      </div>
  </div>
</template>

<script>
  import {Api} from '../../../utils/axios'
  export default {
    data(){
      return{
        evaluateList:[],
        warning:'',
        baseData:JSON.parse(this.$route.query.dataObj),
        evaText:'',
      }
    },
    methods:{
      async submintPjData(){
        if(this.evaText.trim()==''){
          this.$toast("评价内容不能为空！");
          return;
        }
        const params = {
          jx0404id:this.baseData.jx0404id,
          evaText:this.evaText,
          jg0101id:this.baseData.jg0101id
        };
        const res = await Api.submitEvaluateOnTime(params);
        if(res.code=='1'){
          this.$toast("提交成功！");
          setTimeout(() => {
          this.$router.push({
             path:'/student/evaluateOnTime',
            });
            }, 1500);
            }
      },
      lookMyEvaluateRecod(){
        this.$router.push({
                path: '/student/findMyEvaluateRecod',
                query: {
                  dataObj: JSON.stringify(this.baseData)
                }
            });
      }
    },
    created(){
      this.$store.state.evaOptCheck = []
      this.getEvaluation()
    },
  }
</script>

<style lang="less" scoped>
.tittleDiv{
  padding: 3% 5% 0;
	background-color: #ffffff;
	height: 80px;
	.list-head {
	  height: 100%;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
    p {
		height: 22px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #fff;
		letter-spacing: 0;
		line-height: 22px;
		font-weight: 500;
		margin-bottom: 2%;
	  }
    ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  opacity: 0.8;
		}
  }
}
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{
    padding: 3% 5% 0;
    position: fixed;
    top: 140px;
    bottom: 90px;
    width: 95%;
    p{
      font-family: PingFangSC-Medium;
      color: #151618;
      font-size: 15px;
      font-weight: 600;
      line-height: 25px;
    }
    span {
      color: @attendance-color-2;
      position: relative;
      bottom: 0px;
      right: 10px;
      color: red;
      font-size: 12px;
   }
   .eva-body-ts{
     text-align: right;
     padding: 3% 5% 0;
     padding-top:0;
   }
  }
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 10px;box-sizing: border-box;height: 85px;}
  .history-btn button{width: 40%;background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;}

 .eva-body textarea {
   width: 95%;
   padding: 10px;
   background-color: @attendance-background-color-6;
   border-radius: 3px;
   box-sizing: border-box;
   color: @attendance-color-1;
   height: 85%;
   padding-bottom: 15px;
   position: relative;
 }
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/teachEvaluateOnTime.vue